import { isAfter, isValid, parse, startOfToday } from 'date-fns';
import { z } from 'zod';

import { phoneNumberRegex, zipCodeRegex } from '@/lib/validation-regex';

const zipCodeSchema = z.string().regex(zipCodeRegex, 'Zip code must be 5 digits');

const dateOfBirthSchema = z
  .string()
  .min(1, 'Please make a selection')
  .refine(
    (date) => {
      if (!date) return false;
      // Ensure the date string matches MM/DD/YYYY format exactly (4-digit year required)
      const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      if (!datePattern.test(date)) return false;

      const parsedDate = parse(date, 'MM/dd/yyyy', new Date());
      return isValid(parsedDate);
    },
    { message: 'Please enter a valid date' }
  )
  .refine(
    (date) => {
      if (!date) return false;
      const parsedDate = parse(date, 'MM/dd/yyyy', new Date());

      if (!isValid(parsedDate)) return false;
      return !isAfter(parsedDate, startOfToday());
    },
    { message: 'Date cannot be in the future' }
  );

const phoneNumberSchema = z
  .string()
  .min(10, 'Phone number is required')
  .max(10, {
    message: 'Phone number must contain at most 10 characters',
  })
  .regex(phoneNumberRegex, 'Please enter a valid phone number');

const emailSchema = z.email('Please enter a valid email address');

export { dateOfBirthSchema, phoneNumberSchema, emailSchema, zipCodeSchema };
